import { UpdateDeltaCalculator } from "./UpdateDeltaCalculator";
import { findAllSongsheetCacheKeys } from "./CacheManager";
import { buildUrlListForAllPagesOfAllSongs } from "./BuildUrlListForAllPagesOfAllSongs";
import { SongUb } from "../gql/graphql";

export class DownloadNecessityChecker {
  public isFileDownloadNecessary(
    songList: readonly SongUb[],
  ): Promise<boolean> {
    return findAllSongsheetCacheKeys()
      .then((cacheUrls: string[]) => {
        const urlsToBeDownloaded =
          new UpdateDeltaCalculator().calculateToBeDownloaded(
            buildUrlListForAllPagesOfAllSongs(songList),
            new Set(cacheUrls),
          );
        console.log(
          "update necessity check: " +
            urlsToBeDownloaded.length +
            " urls need to be downloaded.",
        );
        return Promise.resolve(urlsToBeDownloaded.length > 0);
      })
      .catch((e) => {
        console.error(e.message);
        return Promise.resolve(false);
      });
  }
}
